import { Components } from '@mui/material';

export const components: Components = {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableElevation: true,
      variant: 'outlined',
    },
    styleOverrides: {
      root: {
        borderRadius: '2px',
        border: '1px solid #181818',
        margin: 0,
        textTransform: 'uppercase',
      },
      sizeLarge: {
        padding: '16px 40px',
      },
      outlinedPrimary: {
        '&:hover': {
          background: '#181818',
          color: '#ffffff',
        },
        '&:active': {
          background: '#2e2d2d',
          color: '#ffffff',
        },
      },
    },
  },
  MuiContainer: {
    defaultProps: {
      maxWidth: 'lg1286',
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        margin: 0,
        gap: '1rem',
      },
    },
  },
  MuiTextField: {
    defaultProps: {},
    styleOverrides: {
      root: {
        borderRadius: 0,
        margin: 0,
      },
    },
  },
};
